import React from "react";
import { TherapistProfile } from "@/types/therapist";
import TherapistCard from "./TherapistCard";

interface TherapistListProps {
  therapists: TherapistProfile[];
  userRole: string | null;
}

const TherapistList = ({ therapists, userRole }: TherapistListProps) => {
  if (therapists.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">No premium therapists are currently available.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {therapists.map((therapist) => (
        <TherapistCard 
          key={therapist.id} 
          therapist={therapist} 
          userRole={userRole}
        />
      ))}
    </div>
  );
};

export default TherapistList;
